import {
  modalSubject,
  paywallSubject,
  personalizedReadingHubSubject,
  stickyBannerBottomSubject,
} from './constants';
import {
  AnyBlueconicEvent,
  BlueconicAppDownloadModalEvent,
  BlueconicCustomUrlModalEvent,
  BlueconicLeadCaptureModalEvent,
  BlueconicLeadCaptureModalHorizontalArticlesEvent,
  BlueconicLeadCaptureModalSingleArticleEvent,
  BlueconicLeadCaptureModalSplitImgEvent,
  BlueconicLeadCaptureModalVerticalArticlesEvent,
  BlueconicLeadCaptureModalWithMultipleSubscribeOptionsEvent,
  BlueconicLeadCaptureModalWithNewsletterEvent,
  BlueconicLeadCaptureModalWithNewslettersEvent,
  BlueconicNewsletterModalEvent,
  BlueconicPaywallEvent,
  BlueconicPersonalizedReadingHubEvent,
  BlueconicRetentionP0Event,
  BlueconicRetentionP1Event,
  BlueconicRetentionP2Event,
  BlueconicRetentionP3Event,
  BlueconicRetentionP4Event,
  BlueconicStickyBannerBottomEvent,
} from './eventsInterfaces';
import {
  BlueconicDialogues,
  BlueconicPaywallProps,
  BlueconicPersonalizedReadingHubProps,
  BlueconicRetentionP0Props,
  BlueconicRetentionP1Props,
  BlueconicRetentionP2Props,
  BlueconicRetentionP3Props,
  BlueconicRetentionP4Props,
  BlueconicStickyBannerBottomProps,
} from './propInterfaces';
import {
  isBlueconicAppDownloadModalProps,
  isBlueconicCustomUrlModalProps,
  isBlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps,
  isBlueconicLeadCaptureModalWithNewsletterProps,
  isBlueconicLeadCaptureModalWithNewslettersProps,
  isBlueconicLeadCaptureProps,
  isBlueconicNewsletterModalProps,
  isBlueconicPaywallProps,
  isBlueconicPersonalizedReadingHubProps,
  isBlueconicRetentionP0Props,
  isBlueconicRetentionP1Props,
  isBlueconicRetentionP2Props,
  isBlueconicRetentionP3Props,
  isBlueconicRetentionP4Props,
  isBlueconicStickyBannerBottomProps,
  isBlueconicSubscribeModalProps,
} from './typeGuards';

export function verifyBlueconicDialogue(event: AnyBlueconicEvent): boolean {
  if (!event || !event.data || !event.data.dialogueType) return false;

  const dialogueType = BlueconicDialogues[getEnumKeyByValue(event.data.dialogueType)];

  switch (dialogueType) {
    case BlueconicDialogues.CustomUrlModal:
      if (isBlueconicCustomUrlModalProps(event.data as BlueconicCustomUrlModalEvent['data'])) {
        modalSubject.next(event as BlueconicCustomUrlModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.AppDownload:
      if (isBlueconicAppDownloadModalProps(event.data)) {
        modalSubject.next(event as BlueconicAppDownloadModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.NewsletterModal:
      if (isBlueconicNewsletterModalProps(event.data as BlueconicNewsletterModalEvent['data'])) {
        modalSubject.next(event as BlueconicNewsletterModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.Paywall:
      if (isBlueconicPaywallProps(event.data as BlueconicPaywallProps)) {
        paywallSubject.next(event as BlueconicPaywallEvent);
        return true;
      }
      break;
    case BlueconicDialogues.StickyBannerBottom:
      if (isBlueconicStickyBannerBottomProps(event.data as BlueconicStickyBannerBottomProps)) {
        stickyBannerBottomSubject.next(event as BlueconicStickyBannerBottomEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModal:
      if (isBlueconicLeadCaptureProps(event.data as BlueconicLeadCaptureModalEvent['data'])) {
        modalSubject.next(event as BlueconicLeadCaptureModalEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithVerticalArticles:
      if (
        isBlueconicLeadCaptureProps(
          event.data as BlueconicLeadCaptureModalVerticalArticlesEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalVerticalArticlesEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithHorizontalArticles:
      if (
        isBlueconicLeadCaptureProps(
          event.data as BlueconicLeadCaptureModalHorizontalArticlesEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalHorizontalArticlesEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithSingleArticle:
      if (
        isBlueconicLeadCaptureProps(
          event.data as BlueconicLeadCaptureModalSingleArticleEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalSingleArticleEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithSplitImg:
      if (
        isBlueconicSubscribeModalProps(event.data as BlueconicLeadCaptureModalSplitImgEvent['data'])
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalSplitImgEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithNewsletters:
      if (
        isBlueconicLeadCaptureModalWithNewslettersProps(
          event.data as BlueconicLeadCaptureModalWithNewslettersEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalWithNewslettersEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithNewsletter:
      if (
        isBlueconicLeadCaptureModalWithNewsletterProps(
          event.data as BlueconicLeadCaptureModalWithNewsletterEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalWithNewsletterEvent);
        return true;
      }
      break;
    case BlueconicDialogues.LeadCaptureModalWithMultipleSubscribeOptions:
      if (
        isBlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps(
          event.data as BlueconicLeadCaptureModalWithMultipleSubscribeOptionsEvent['data']
        )
      ) {
        modalSubject.next(event as BlueconicLeadCaptureModalWithMultipleSubscribeOptionsEvent);
        return true;
      }
      break;
    case BlueconicDialogues.PersonalizedReadingHub:
      if (
        isBlueconicPersonalizedReadingHubProps(event.data as BlueconicPersonalizedReadingHubProps)
      ) {
        personalizedReadingHubSubject.next(event as BlueconicPersonalizedReadingHubEvent);
        return true;
      }
      break;
    case BlueconicDialogues.RetentionP0ContentSmall:
      if (isBlueconicRetentionP0Props(event.data as BlueconicRetentionP0Props)) {
        modalSubject.next(event as BlueconicRetentionP0Event);
        return true;
      }
      break;
    case BlueconicDialogues.RetentionP1SingleContentHighlightText:
      if (isBlueconicRetentionP1Props(event.data as BlueconicRetentionP1Props)) {
        modalSubject.next(event as BlueconicRetentionP1Event);
        return true;
      }
      break;
    case BlueconicDialogues.RetentionP2SingleContentHighlightImage:
      if (isBlueconicRetentionP2Props(event.data as BlueconicRetentionP2Props)) {
        modalSubject.next(event as BlueconicRetentionP2Event);
        return true;
      }
      break;
    case BlueconicDialogues.RetentionP3MultipleContentText:
      if (isBlueconicRetentionP3Props(event.data as BlueconicRetentionP3Props)) {
        modalSubject.next(event as BlueconicRetentionP3Event);
        return true;
      }
      break;
    case BlueconicDialogues.RetentionP4MultipleContentImage:
      if (isBlueconicRetentionP4Props(event.data as BlueconicRetentionP4Props)) {
        modalSubject.next(event as BlueconicRetentionP4Event);
        return true;
      }
      break;
    default:
      return false;
  }

  return false;
}

function getEnumKeyByValue(value: string): keyof typeof BlueconicDialogues {
  return (Object.keys(BlueconicDialogues) as Array<keyof typeof BlueconicDialogues>).find(
    (key) => BlueconicDialogues[key] === value
  );
}
